<template>
  <div class="container">
    <label v-if="selfContent.label" :class="[{'required': selfContent.required,'read-only': selfContent.readOnly}]">
      {{ selfContent.label }}
    </label>
    <div class="radio-container" :class="{'bad_input': selfContent.error,'read-only': selfContent.readOnly}">
      <label v-for="(item, index) in selfContent.values" :key="index" class="radio-option">
        <input
            type="radio"
            :name="selfContent.name"
            :value="item.value"
            :checked="selfContent.value === item.value"
            :disabled="selfContent.readOnly"
            @change="selectThis(item.value)"
        />
        <span class="radio"></span>
        <span class="radio-label">{{ item.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomRadioField",
  props: ["content"],
  data() {
    return {
      selfContent: this.content
    };
  },
  methods: {
    selectThis(value) {
      if (this.selfContent.readOnly) {
        return;
      }

      this.selfContent.value = value;
      this.selfContent.error = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.container
  position relative
  width 100%

// Libellé : légende au-dessus du champ (dans le flux, plus de pastille sur la bordure)
.container > label
  display block
  margin 8px 0 4px 2px
  font-weight 600
  font-size 0.82em
  color CTRL_LABEL

  &.read-only
    color CTRL_TEXT_MUTED

  &.required::after
    content "*"
    margin-left 4px
    font-weight bold
    color CTRL_ERROR

.radio-container
  display flex
  flex-direction column
  align-items flex-start
  gap 10px

  box-sizing border-box
  width 100%
  min-height CTRL_HEIGHT
  padding 10px CTRL_PADDING_X

  border 1px solid CTRL_BORDER
  border-radius CTRL_RADIUS
  background-color CTRL_BG
  transition background-color CTRL_EASE, border-color CTRL_EASE

.radio-option
  display flex
  align-items center
  gap 10px
  cursor pointer
  user-select none

.radio-option input
  display none

.radio
  position relative
  flex none
  width 18px
  height 18px
  border 2px solid #aab4c8
  border-radius 50%
  box-sizing border-box
  background-color white
  transition border-color CTRL_EASE

.radio-option:hover .radio
  border-color CTRL_FOCUS

.radio-option input:checked + .radio
  border-color THEME_COLOR_PRIMARY

.radio-option input:checked + .radio::after
  content ''
  position absolute
  width 10px
  height 10px
  top 2px
  left 2px
  border-radius 50%
  background THEME_COLOR_PRIMARY

.radio-label
  color CTRL_TEXT

.radio-option input:disabled + .radio
  border-color CTRL_DISABLED_TEXT
  background-color transparent

.radio-option input:disabled:checked + .radio::after
  background CTRL_DISABLED_TEXT

.radio-option input:disabled ~ .radio-label
  color CTRL_TEXT_MUTED

.radio-container.read-only
  background-color CTRL_DISABLED_BG
  border-color transparent
  cursor auto

.radio-container.read-only .radio-option
  cursor default

.bad_input
  border-color CTRL_ERROR
  background-color CTRL_ERROR_BG
</style>